import MaterialTable, { MTableBodyRow } from '@material-table/core'
import { Chip, IconButton } from '@material-ui/core'
import { makeStyles, MuiThemeProvider } from '@material-ui/core/styles'
import CreateIcon from '@material-ui/icons/Create'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { showError } from '../../actions/misc/misc.actions'
import { getChipStyles } from '../../services/helpers'
import { tableAlternateDark } from '../../services/theme'
import { EditAddOnDialog } from '../Dialogs'

const useStyles = makeStyles((theme) => ({
	chipRow: {
		height: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center'
	},
	addOnRow: {
		'&:hover': {
			'& .addOnButton': {
				opacity: 0.6,
				transition: 'opacity 250ms ease-in-out'
			}
		},
		'& .addOnButton': {
			color: '#777679',
			size: '12px',
			opacity: 0,
			transition: 'opacity 250ms ease-in-out'
		}
	}
}))

const AddOnsTable = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const facility = useSelector((state) => state.specific.facilities.selected)

	const [selectedAddOn, setSelectedAddOn] = useState(null)
	const [isShown, setIsShown] = useState(false)
	const [addOns, setAddOns] = useState([])
	const { grooming, forceOneAddonSelected, shouldShowMainGroomingService, visit } = props

	useEffect(() => {
		if (props.addOns) {
			if (grooming && shouldShowMainGroomingService) {
				const adds = [...props.addOns]
				const groomingServices = facility?.services?.grooming?.services || []
				const mainService = groomingServices.find((gs) => gs.type === visit.grooming_service_type)
				if (mainService) {
					const mainPrice = visit.price ?? visit.quoted_price_min
					adds.unshift({
						name: mainService.name,
						...(mainPrice != null ? { price: mainPrice } : {}),
						status: visit.grooming_status || 'Upcoming'
					})
				}
				setAddOns(adds)
			} else {
				try {
					setAddOns(props?.addOns || [])
				} catch (e) {
					console.error('AddOnsTable: failed to set addOns', e)
				}
			}
		}
	}, [props.addOns, grooming, shouldShowMainGroomingService, visit, facility])

	const renderStatus = (addOn) => {
		let status = addOn.completed ? 'Completed' : 'Upcoming'

		if (addOn.status) status = addOn.status

		return (
			<div className={classes.chipRow}>
				<Chip label={status ? status : 'No Status'} style={status ? getChipStyles(status) : null} />
			</div>
		)
	}

	const renderGroomingStatus = (addOn) => {
		let status = visit?.grooming_status || 'Upcoming'

		return (
			<div className={classes.chipRow}>
				<Chip label={status ? status : 'No Status'} style={status ? getChipStyles(status) : null} />
			</div>
		)
	}

	const isDeleteAllowed = (addOn) => {
		if (
			forceOneAddonSelected &&
			addOn?.category === 'meal' &&
			addOns.filter((a) => a.category === 'meal' && !a.skipped).length === 1
		) {
			const error = 'Boarding dogs must have at least one meal occurence each day'
			dispatch(showError(error))
			return false
		}
		return true
	}

	const renderPrice = (addOn) => {

		if (!facility || !facility.add_on_services) return '$0.00'

		if (addOn.category === 'meal') return '$0.00'
		let facilityAddOn
		if (addOn.category === 'meal') return '$0.00'
		if (addOn.type) {
			facilityAddOn = facility.add_on_services[addOn.type]?.find(
				(add_on_service) => addOn.addon_id === add_on_service._id
			)
		}

		let finalPrice = 'price' in addOn ? addOn.price : facilityAddOn ? facilityAddOn.price : 0
		// addon choice logic
		const addon_choice_id = addOn.addon_choice_id
		const hasAddonChoice = !!addon_choice_id
		if (hasAddonChoice && facilityAddOn?.addon_choices?.length && !('price' in addOn)) {
			const selectedChoice = facilityAddOn.addon_choices.find((c) => c.id === addon_choice_id)
			if (selectedChoice) {
				finalPrice += Number(selectedChoice.upcharge)
			}
		}

		return `$ ${(finalPrice / 100).toFixed(2)}`
	}

	const renderName = (add) => {
		if (add.category === 'meal') return add.category

		if (add.med_id) return `Medication - ${add.name}`

		let finalName = add.name || ''
		const addOn = facility.add_on_services[add.type]?.find((addOnService) => addOnService._id === add.addon_id)

		// addon choice logic
		const addon_choice_id = add.addon_choice_id
		const hasAddonChoice = !!addon_choice_id
		if (hasAddonChoice && addOn?.addon_choices?.length) {
			const selectedChoice = addOn.addon_choices.find((c) => c.id === addon_choice_id)
			if (selectedChoice) {
				finalName = finalName ? `${finalName} - ${selectedChoice.name}` : selectedChoice.name
			}
		}

		return finalName
	}

	const showEditAddOn = (addOn) => {
		setSelectedAddOn(addOn)
		setIsShown(true)
	}

	return (
		<div>
			<MuiThemeProvider theme={tableAlternateDark}>
				<MaterialTable
					style={{
						boxShadow: 'none',
						borderRadius: '0px'
					}}
					options={{
						headerStyle: {
							color: '#1A1A35',
							textTransform: 'uppercase',
							fontWeight: 800,
							fontSize: '12px',
							lineHeight: '16px',
							padding: '11px 24px',
							backgroundColor: '#F9F9F9'
						},
						actionsColumnIndex: -1,
						toolbarButtonAlignment: 'left',
						searchFieldAlignment: 'left',
						paging: false,
						toolbar: false
					}}
					localization={{
						header: {
							actions: ''
						}
					}}
					columns={
						grooming && !shouldShowMainGroomingService
							? [
								{
									title: 'Type',
									render: (data) => renderName(data),
									cellStyle: { textTransform: 'capitalize' }
								},
								{ title: 'Price', render: (data) => renderPrice(data) }
							]
							: grooming && shouldShowMainGroomingService
								? [
									{
										title: 'Type',
										render: (data) => renderName(data),
										cellStyle: { textTransform: 'capitalize' }
									},
									{ title: 'Price', render: (data) => renderPrice(data) },
									//{ title: "", field: "alerts" },
									{ title: 'Status', render: (data) => renderGroomingStatus(data) }
								]
								: [
									{
										title: 'Activity',
										render: (data) => renderName(data),
										cellStyle: { textTransform: 'capitalize' }
									},
									{
										title: 'Timeblock',
										field: 'time',
										cellStyle: { textTransform: 'capitalize' }
									},
									{ title: 'Price', render: (data) => renderPrice(data) },
									//{ title: "", field: "alerts" },
									{ title: 'Status', render: (data) => renderStatus(data) }
								]
					}
					actions={[
						(rowData) => ({
							tooltip: 'Edit'
							//onClick: (event, rowData) => showEditAddOn(rowData),
						})
					]}
					data={addOns}
					components={{
						Action: (props) => {
							return (
								<IconButton
									className={'addOnButton'}
									onClick={(event) => showEditAddOn(props.data)}>
									<CreateIcon />
								</IconButton>
							)
						},
						Row: (props) => <MTableBodyRow className={classes.addOnRow} {...props} />
					}}
				/>
			</MuiThemeProvider>
			<EditAddOnDialog
				addOn={selectedAddOn || {}}
				setSelectedAddOn={setSelectedAddOn}
				isShown={isShown}
				setIsShown={setIsShown}
				isDeleteAllowed={isDeleteAllowed}
			/>
		</div>
	)
}

export default AddOnsTable
